import React from 'react';
import SMConst from 'lib/SMConst';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMUserResource from 'resources/SMUserResource';
import SMRestClient from 'lib/SMRestClient';
import update from 'react-addons-update';
import SMAppHelper from 'components/helpers/SMAppHelper';
import Spinner from 'components/shared/SMMaterialSpinner';

class SMOwnerMenuView extends React.Component {
  
  constructor(props) {
    super(props);
    this.currentPage = this.props.page;
    this.canRequest = true;
    this.state = {
      display: this.props.display,
      listItems: [],
    };
  }
  
  componentDidMount() {
    this.spinnerRadius = 10;
    this.spinnerStrokeWidth = 2;
    $(document).on("SMHideBaloon", this.hide.bind(this));
  }
  
  componentWillUnmount() {
    $(document).off("SMHideBaloon", this.hide);
  }
  
  componentWillUpdate(nextProps, nextState) {
    $(this.refs.navigationTable).off("scroll", this.tableViewDidScroll);
  }
  
  componentDidUpdate(prevProps, prevState) {
    $(this.refs.navigationTable).on("scroll", this.tableViewDidScroll.bind(this));
  }
  
  tableViewDidScroll(e){
    SMAppHelper.observeScrollToBottom(e.currentTarget, ()=>{
      this.requestResource(true);
    });
  }
  
  requestResource(isAppend, callback){
    if (!this.canRequest) return;
    this.canRequest = false;
    //if (!isAppend) this.setState({display: SMConst.Display.Loading});
    if (!isAppend) this.setState({display: SMConst.Display.Hidden});
    let queries = {};
    if (this.currentPage != 1) queries["page"] = this.currentPage;
    SMUserResource.getOwners(this.props.currentUser.username, queries, (responses, error, xhr)=>{
      //if(this.state.display == SMConst.Display.Hidden) return;
      if(error || !responses) return;
      let links = SMRestClient.getLinks(xhr),
          listItems = this.state.listItems;
      if (links["next"]) {
        this.canRequest = true;
      }
      listItems = update(listItems, {$push: responses});
      if (responses.length == 0) {
        window.location = Routes.sign_up_owners_path();
      }
      else if (listItems.length == 1) {
        window.location = Routes.owner_dashboard_path(listItems[0].username);
      } else {
        this.setState({display: SMConst.Display.Visible});
        this.currentPage++;
        this.setState({
          listItems: listItems,
        });
      }
      
    });
  }
  
  linkClick(e) {
    e.stopPropagation();
  }
  
  toggle(e){
    e.stopPropagation();
    e.preventDefault();
    if (this.state.display == SMConst.Display.Hidden) {
      this.show(e);
    } else {
      this.hide(e);
    }
  }
  
  show(e) {
    $(document).trigger("SMHideBaloon");
    this.requestResource();
  }
  
  hide(e) {
    this.setState({display: SMConst.Display.Hidden});
  }
  
  renderDefault() {
    let rows = [];
    for (let i in this.state.listItems) {
      let owner = this.state.listItems[i];
      rows.push(
        <li key={owner.id} className="site-header__nav-baloon-menu clearfix">
          <a onClick={this.linkClick} href={Routes.owner_dashboard_path(owner.username)} className="link-black link-borderless">
            <p><img src={owner.profile_image} alt={SMFormatHelper.ownerName(owner)} /></p>
            <p>{SMFormatHelper.ownerName(owner)}</p>
          </a>
        </li>
      );
    }
    if (this.canRequest) {
      rows.push(
        <li key={rows.length} className="js-loading-row">読み込んでいます...</li>
      );
    }
    return <ul>{rows}</ul>;
  }
  
  renderLoading() {
    return (
      <div className="js-empty"><Spinner /></div>
    );
  }
  
  render() {
    let style = {
      display: (this.state.display == SMConst.Display.Hidden) ? "none" : ""
    };
    let content = "";
    switch (this.state.display) {
      case SMConst.Display.Loading: 
        content = this.renderLoading();
        break;
      default: 
        content = this.renderDefault();
        break;
    }
    return(
      <li>
        <a onClick={this.toggle.bind(this)} href="#" className="site-header__nav-owner button-green">
          スペースを管理する<i className="fa fa-caret-down ml5"></i>
        </a>
        <div style={style} className="baloon baloon-top site-header__nav-baloon site-header__nav-baloon-owner">
          <div ref="navigationTable" className="baloon-inner">
            {content}
          </div>
        </div>
      </li>
    );
  }
}
SMOwnerMenuView.defaultProps = {
  display: SMConst.Display.Hidden,
  page: 1,
  perPage: 20,
};
export default SMOwnerMenuView;




// WEBPACK FOOTER //
// ./app/javascript/components/header/SMOwnerMenuView.jsx